/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkSecurityPolicyModule
 */

import { INetworkSecurityMatchTarget } from 'generated-types';

import {
    IpAddrMatchConfigItem,
    IPReputationTypeMatchConfigItem,
    PortMatchConfigItem,
} from 'ajs/modules/match';

import { NetworkSecurityMatchTarget } from 'object-types';
import {
    PolicyMatchConfigItem,
} from '../../policies/factories/config-items/policy-match.config-item.factory';

/**
 * Interface for NetworkSecurity Match Target Partial.
 */
interface INetworkSecurityMatchTargetConfig
    extends Omit<INetworkSecurityMatchTarget, 'client_ip' | 'vs_port' | 'ip_reputation_type'>
{
    client_ip?: IpAddrMatchConfigItem;
    vs_port?: PortMatchConfigItem
    ip_reputation_type?: IPReputationTypeMatchConfigItem;
}

/**
 * @description NetworkSecurityMatchTarget MessageItem class.
 * @author Abhinesh Gour
 */
export class NetworkSecurityMatchTargetConfigItem
    extends PolicyMatchConfigItem<INetworkSecurityMatchTargetConfig> {
    public getConfig: () => INetworkSecurityMatchTargetConfig;
    constructor(args = {}) {
        const extendedArgs = {
            objectType: NetworkSecurityMatchTarget,
            ...args,
        };

        super(extendedArgs);
    }
}
